import React, { memo } from "react";
import { ReactSVG } from "react-svg";
import { classNames } from "helpers";

export interface TableViewToggleOption {
  value: string;
  label: string;
  icon: string;
}

export interface TableViewToggleProps {
  value: string;
  onChange: (value: string) => void;
  options: TableViewToggleOption[];
}

const TableViewToggle: React.FC<TableViewToggleProps> = ({
  value,
  onChange,
  options,
}) => {
  return (
    <div className="flex gap-2">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={classNames(
            "flex items-center gap-2 px-3 py-1.5 rounded-sm text-sm font-medium transition-colors",
            value === option.value
              ? "bg-blue-100 text-blue-600"
              : "bg-slate-100 text-slate-600 hover:bg-blue-100 hover:text-blue-600"
          )}
        >
          <ReactSVG
            src={option.icon}
            className={classNames("w-4 h-4",
              value === option.value ? "stroke-white" : "stroke-slate-500"
            )}
          />
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default memo(TableViewToggle);
